export default class VoyageOptionsData {
    constructor(
        maxServiceSpeed,
        minServiceSpeed,
        maxCruiseSpeed,
        minCruiseSpeed,
        maxServicePower = 12000.0,
        minServicePower = 8000.0,
        maxServiceRpm = 120.0,
        minServiceRpm = 50.0,
        vesselDraft = 10.0,
        etdWindow = 24,
        navigationMode = 2,
        useTss = true,
        useEca = true,
        useTrs = false,
        useSuez = true,
        usePanama = true,
        useKiel = false,
        useTaiwanStrait = false,
        avoidPiracy = true,
        useDatasets = false,
        keepVoyageData = true,
        landProximity = 2.0,
        fuel = null,
        constraints = null,
        tweaks = null,
        savings = null,
        dailyRate = null,
        operationalMode = "STW",
        dta = null,
        arrivalWindow = null,
        keepAllSolutions = true,
        customAreas = null
    ) {
        this.maxServiceSpeed = maxServiceSpeed,
            this.minServiceSpeed = minServiceSpeed,
            this.maxCruiseSpeed = maxCruiseSpeed,
            this.minCruiseSpeed = minCruiseSpeed,
            this.maxServicePower = maxServicePower,
            this.minServicePower = minServicePower,
            this.maxServiceRpm = maxServiceRpm,
            this.minServiceRpm = minServiceRpm,
            this.vesselDraft = vesselDraft,
            this.etdWindow = etdWindow,
            this.navigationMode = navigationMode,
            this.useTss = useTss,
            this.useEca = useEca,
            this.useTrs = useTrs,
            this.useSuez = useSuez,
            this.usePanama = usePanama,
            this.useKiel = useKiel,
            this.useTaiwanStrait = useTaiwanStrait,
            this.avoidPiracy = avoidPiracy,
            this.useDatasets = useDatasets,
            this.keepVoyageData = keepVoyageData,
            this.landProximity = landProximity,
            this.fuel = fuel,
            this.constraints = constraints,
            this.tweaks = tweaks,
            this.savings = savings,
            this.dailyRate = dailyRate,
            this.operationalMode = operationalMode,
            this.dta = dta,
            this.arrivalWindow = arrivalWindow,
            this.keepAllSolutions = keepAllSolutions,
            this.customAreas = customAreas
    }
}